import { CONTENT_GROUP_PARTICIPANTS, popupDismissConstants } from '../constants';

const initialState = { 
    loading: false, 
    data: null
};

export function popup_dismiss(state = initialState, action) {
  switch (action.type) {
    case popupDismissConstants.SET_POPUP_DISMISS: {
        return {
            ...state,
            data: action.payload
        };
    }

    case popupDismissConstants.POPUP_DISMISS_LOADING: {
        return {
            ...state,
            loading: true
        };
    }

    case popupDismissConstants.POPUP_DISMISS_FINISHED_LOADING: {
        return {
            ...state,
            loading: false
        };
    }

    default:
      return state
  }
}
